import React from 'react';

const TRUST_ITEMS = [
    {
        icon: '✓',
        title: 'Source-grounded answers',
        desc: 'Every claim is cited back to an exact page, table, or paragraph. If the data isn\'t there, the system says so.',
    },
    {
        icon: '🔒',
        title: 'Your documents stay yours',
        desc: 'Uploaded reports are stored in your tenant and are never shared across accounts or used to train models.',
    },
    {
        icon: '⚖️',
        title: 'No trading recommendations',
        desc: 'Finlytics is an analytics tool — it surfaces data and ratios, never buy/sell signals or investment advice.',
    },
];

const TrustSection = () => (
    <section className="lp-trust">
        <div className="lp-trust-inner">
            <p className="lp-section-label">Trust & Transparency</p>
            <h2 className="lp-section-title">Built for accuracy, not hype</h2>

            <div className="lp-trust-grid">
                {TRUST_ITEMS.map((item) => (
                    <div className="lp-trust-item" key={item.title}>
                        <div className="lp-trust-icon" aria-hidden="true">{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default TrustSection;
